<app-kpi-widget
  [title]="'driverOverview.widgets.overtime' | transloco: { symbol: currencySymbol }"
  [isLoading]="isLoading"
  [icon]="'ph-clock-afternoon'"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [difference]="difference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [isUptrendPositive]="false"
  [valueFormatter]="formatValue.bind(this)"
  [differenceFormatter]="formatDifference.bind(this)"
  (clicked)="openOvertimeModal()"
  [isMonthToDateOnly]="true"
  [isImageIcon]="false"
  [widgetDisabled]="false"
  [hasFooter]="false"
  [dropdownEnabled]="false">
</app-kpi-widget>